<template>
  <div>
    <div :class="['page-container', variant]">
      <div class="page-content">
        <slot />
        <NavigationMenu />
      </div>
      <div class="page-footer">
        <div class="powered">{{ $t('labels.poweredBy') }} <BlytzLogo /></div>
      </div>
    </div>
    <div v-if="isBusy" class="spinner-container">
      <LoaderCircle :size="24" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { debounce } from 'lodash-es'
import { LoaderCircle } from 'lucide-vue'

import BlytzLogo from '@/components/Elements/Logo/BlytzLogo.vue'
const NavigationMenu = () =>
  import('@/components/NavigationMenu/NavigationMenu.vue')

@Component({
  components: {
    BlytzLogo,
    NavigationMenu,
    LoaderCircle
  }
})
export default class PageContainer extends Vue {
  busyCount = 0
  isBusy = false

  created() {
    this.$eventBus.on('incrementBusy', this.incrementBusy)
    this.$eventBus.on('decrementBusy', this.decrementBusy)
  }

  incrementBusy() {
    this.busyCount += 1
    this.debouncedBusyStarter()
  }

  busyStart() {
    if (this.busyCount) this.isBusy = true
  }

  decrementBusy() {
    this.busyCount -= 1
    this.debouncedBusyChecker()
  }

  busyChecker() {
    this.isBusy = Boolean(this.busyCount)
  }

  debouncedBusyStarter = debounce(this.busyStart, 200, { trailing: true })
  debouncedBusyChecker = debounce(this.busyChecker, 200, { trailing: true })

  get showNav(): boolean {
    const showNav = this.$route.meta.hideNav
    return typeof showNav !== undefined ? showNav : true
  }

  get variant(): string {
    return this.$route?.meta?.pageVariant || ''
  }
}
</script>

<style scoped lang="scss">
.page-container {
  height: 100vh;
  height: -webkit-fill-available;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: column;
  background: $dark-blue;
  background: transparent linear-gradient(334deg, $dark-blue 0%, $blue 100%) 0%
    0% no-repeat padding-box;
}
.page-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
}

.powered {
  color: $steel-gray;
  display: flex;
  font-size: 12px;
  text-align: center;
  background: $black;
  display: block;
  padding: 10px;

  svg {
    height: 16px;
  }
}

.brand-logo {
  height: 25px;
}

.page-nav {
  color: $white;
  position: absolute;
}

.page-footer {
  position: relative;
  &:before {
    content: '';
    display: block;
    position: absolute;
    height: 5px;
    width: 100%;
    background: $black;
    bottom: calc(100% - 1px);
  }
}

.spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  font-size: 5em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($blue, 70%);
  z-index: 15;
  color: white;
}
</style>
